var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2802 13.477V11.6408C14.2802 9.01876 16.3275 6.87964 18.8706 6.87964C21.4137 6.87964 23.461 9.01876 23.461 11.6408V13.477H26.6339C26.7793 13.4771 26.9192 13.5322 27.0255 13.6314C27.1318 13.7305 27.1966 13.8663 27.2068 14.0113L28.2975 30.0777C28.307 30.2294 28.2563 30.3789 28.1562 30.4934C28.0561 30.6079 27.9148 30.6783 27.7631 30.6891H10.0167C9.86473 30.6891 9.71902 30.6287 9.61158 30.5213C9.50414 30.4139 9.44379 30.2682 9.44379 30.1162V30.0777L10.5345 14.0113C10.5442 13.8659 10.6088 13.7298 10.7152 13.6302C10.8215 13.5307 10.9617 13.4753 11.1073 13.4751L14.2802 13.477ZM16.0025 13.477H21.7405V11.6408C21.7405 9.95337 20.4552 8.60012 18.8706 8.60012C17.286 8.60012 16.0025 9.95337 16.0025 11.6408V13.477ZM11.2451 28.9705H26.4962L25.5634 15.1993H12.1797L11.2451 28.9705Z",
    fill: "#475168"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.01177d9ec1e5ae6d8ec963a57820f484.svg";
export { ForwardRef as ReactComponent };